<mat-card appearance="outlined">
  <mat-card-header>
    <div class="header-nombre-nuevo">
      <h2>Registro Contable</h2>
      <app-button-new *appRoles="['RegistrosContable.Crear']"
        (click)="openDialog({ accion: accionesDialog.Agregar, entidad: {idExpediente} })"></app-button-new>
    </div>
  </mat-card-header>
  <!-- Contenido de filtros -->
  <mat-card-content>
    <form [formGroup]="formFilter">
      <div class="row">
        <div class="col-sm-12 col-md-8 col-lg-6" *ngIf="!idExpediente">
          <app-buscar-expediente (eventEntity)="selectExpediente($event)"></app-buscar-expediente>
        </div>

        <div class="col" >
          <mat-form-field appearance="outline" class="w-100">
            <ngx-spinner [zIndex]="-1" name="spTiposRegistroContable" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Tipo Registro Contable</mat-label>
            <mat-select multiple placeholder="Seleccione opcion" formControlName="IdsTipoRegistroContable">
              <mat-option [value]="tipos.id" *ngFor="
                    let tipos of tiposRegistroContable;
                    let i = index;
                    trackBy: trackByItems
                  ">
                {{ tipos.descripcion }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Rango de Fechas</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input matStartDate placeholder="Desde" [formControl]="formFilter.get('FechaDesde')">
              <input matEndDate placeholder="Hasta" [formControl]="formFilter.get('FechaHasta')">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </div>


        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <ngx-spinner [zIndex]="-1" name="spEstadosRegistroContable" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Estado Registro Contable</mat-label>
            <mat-select multiple placeholder="Seleccione opcion" formControlName="IdsEstadoRegistroContable">
              <mat-option [value]="estado.id" *ngFor="
                    let estado of estadosRegistroContable;
                    let i = index;
                    trackBy: trackByItems
                  ">
                {{ estado.descripcion }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <ngx-spinner [zIndex]="-1" name="spCuentaCaja" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Cuentas Cajas</mat-label>
            <mat-select multiple placeholder="Seleccione opcion" formControlName="IdsCuentaCaja">
              <mat-option [value]="cuentaCaja.id" *ngFor="
                    let cuentaCaja of cuentasCaja;
                    let i = index;
                    trackBy: trackByItems
                  ">
                {{ cuentaCaja.descripcion }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <ngx-spinner [zIndex]="-1" name="spCuentaContable" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Cuenta Contable</mat-label>
            <mat-select multiple placeholder="Seleccione opcion" formControlName="IdsTipoRegistroContable">
              <mat-option [value]="cuentaContables.id" *ngFor="
                    let cuentaContables of cuentasContables;
                    let i = index;
                    trackBy: trackByItems
                  ">
                {{ cuentaContables.descripcion }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Rango de Fechas de Alta</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input matStartDate placeholder="FechaAltaDesde" [formControl]="formFilter.get('FechaAltaDesde')">
              <input matEndDate placeholder="FechaAltaHasta" [formControl]="formFilter.get('FechaAltaHasta')">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </div>

        <div class="col" *ngIf="checkedFiltroAvanzado">
          <mat-checkbox formControlName="EsEditable">
            ¿Es Editable?
          </mat-checkbox>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-auto">
          <div style="display: flex; align-items: center; gap: 8px;">
            <app-button-filter-table (click)="aplicarFiltro()"></app-button-filter-table>
            <app-button-filter-table-clear (click)="limpiarFiltro()"></app-button-filter-table-clear>
          </div>

        </div>
        <div class="col-auto">

          <mat-slide-toggle (change)="filtrosAvanzados($event)" color="primary">
            Filtros Avanzados
          </mat-slide-toggle>
        </div>
      </div>
    </form>
  </mat-card-content>

  <mat-card-content>
    <mat-divider></mat-divider>
    <ngx-spinner [zIndex]="100" name="spRegistroContable" bdColor="rgba(255,255,255,0.8)" size="default"
      color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
    </ngx-spinner>

    <!-- Inicio Contenedor acciones tabla -->
    <div class="contenedor-acciones-tablas">
      <div class="acciones-tabla">
        <!-- Boton de Acciones -->
        <!-- <app-button-action></app-button-action> -->
      </div>
      <mat-form-field appearance="outline" *ngIf="data" class="buscador-tabla">
        <mat-icon matPrefix>search</mat-icon>
        <mat-label>Buscar</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Buscar" #input />
      </mat-form-field>
    </div>
    <!-- Fin Contenedor acciones tabla -->

    <div *ngIf="data">
      <table class="mat-elevation-z8" mat-table [dataSource]="dataSource" matSort matSortStart="asc">
        <ng-container matColumnDef="fecha">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Fecha</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let RegistroContable">
            {{ RegistroContable.fecha | date : "short" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="tipoRegistroContable">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Tipo</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let RegistroContable">
            {{ RegistroContable.tipoRegistroContable?.descripcion | titlecase}}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="estadoRegistroContable">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header><strong>Estado</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let RegistroContable">
            {{ RegistroContable.estadoRegistroContable?.descripcion | titlecase }}
          </mat-cell>
        </ng-container>



        <ng-container matColumnDef="importe">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header><strong>Importe</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let RegistroContable">
            {{
            RegistroContable.importe | currency
            }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="etiquetas">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header><strong>Etiquetas</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let RegistroContable">
            <div [innerHTML]="RegistroContable.etiqueta | etiquetas"></div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="aprobadoPor">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header><strong>Aprobado por</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let RegistroContable">
            <app-avatar-iniciales [nombre]='RegistroContable.aprobadoPor?.nombre'
              [apellido]='RegistroContable.aprobadoPor?.apellido'
              [activo]='RegistroContable.aprobadoPor?.activo'></app-avatar-iniciales>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="estados">
          <mat-header-cell mat-header-cell *matHeaderCellDef><strong>Estados</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let RegistroContable">
            <mat-icon class="icon-hover" matTooltip="Es editable" *ngIf="!RegistroContable.esEditable">edit</mat-icon>
            <mat-icon class="icon-hover" matTooltip="Tiene archivo" *ngIf="!RegistroContable.idArchivo">file</mat-icon>
          </mat-cell>
        </ng-container>

        <!-- Accion Column -->
        <ng-container matColumnDef="accion">
          <mat-header-cell mat-header-cell *matHeaderCellDef>
            <strong>Acción</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let RegistroContable" class="action-link">
            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Ver, entidad: {RegistroContable} })"
                *appRoles="['RegistrosContable.Ver']">
                <mat-icon>visibility</mat-icon>
                <span>Ver</span>
              </button>
              <button mat-menu-item
                (click)="openDialog({ accion: accionesDialog.Modificar, entidad: {RegistroContable} })"
                *appRoles="['RegistrosContable.Modificar']">
                <mat-icon>edit</mat-icon>
                <span>Editar</span>
              </button>
              <button mat-menu-item
                (click)="openDialog({ accion: accionesDialog.Eliminar, entidad: {RegistroContable} })"
                *appRoles="['RegistrosContable.Eliminar']">
                <mat-icon>delete</mat-icon>
                <span>Eliminar</span>
              </button>
            </mat-menu>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row matRipple *matRowDef="let row; columns: displayedColumns"></mat-row>
      </table>

      <mat-paginator showFirstLastButtons class="paginator" *ngIf="data" [pageSize]="20"
        [pageSizeOptions]="[5, 10, 20, 50, 100, 200]">
      </mat-paginator>
    </div>
    <app-sin-datos-para-mostrar [dataSource]="dataSource"></app-sin-datos-para-mostrar>
  </mat-card-content>
</mat-card>
